import styled from '@emotion/styled'
import { Box } from '../box'

export const CartContainer = styled(Box)`
  //position: absolute;
  //right: 0;
  z-index: 2;
  height: 100%;

  ::before {
    position: absolute;
    content: '';
    height: 100%;
    width: 1rem;
    background: rgb(255, 255, 255);
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 1) 100%
    );
    left: -1rem;
    top: 0;
  }
`

export const NavSticky = styled.nav`
  position: sticky;
  top: 0;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.15);
  background: white;
  z-index: 990;

  .in-context-flow & {
    display: none;
  }
`

export const NavSlider = styled(Box)`
  ::-webkit-scrollbar {
    display: none;
  }
  p {
    transition: color 0.3s;
  }
`
export const NavRow = styled(Box)`
  ::before {
    position: absolute;
    content: '';
    height: 100%;
    width: 1rem;
    background: rgb(255, 255, 255);
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 0) 100%
    );
    left: 0;
    top: 0;
    z-index: 2;
  }
`

export const SearchContainer = styled(Box)`
  display: flex;
  align-items: center;
  flex: 1;
  transition: opacity 0.2s ease-out;
  max-width: 14rem;
  margin-right: 50px;

  opacity: ${props => (props.show ? 1 : 0)};
  pointer-events: ${props => (props.show ? 'all' : 'none')};
`
